/**
 * Created by Kaku.Guo on 2018/11/23.
 */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { CommentComponent } from '../../index';
import { scrollToReviewTab } from '../../review/reviewUtils';

const AssetDetailComment = (props) => {
    const {
        messages,
        assetData = {},
        commentObjectId,
        renderFooter
    } = props;

    useEffect(() => {
        scrollToReviewTab();
    }, []);

    const prefixCls = 'asset-comment-container';
    return (
        <div className={prefixCls}>
            <CommentComponent
                seller={assetData.seller}
                commentObjectId={commentObjectId}
                commentNamespace="A"
                enableMarkdown={true}
                enableAvatar={false}
                showSort={true}
                enableTimeAgo={false}
                sortDir="DESC"
                replyInitCount="3"
                replyAppendCount="5"
                paginationCount="5"
                paginationType="loadMore"
                messages={messages}
            />
            <div className={`${prefixCls}__footer`}>
                {renderFooter()}
            </div>
        </div>
    );
};
AssetDetailComment.propTypes = {
    messages: PropTypes.object,
    assetData: PropTypes.object,
    commentObjectId: PropTypes.string,
    renderFooter: PropTypes.func
};
export default AssetDetailComment;